module.exports = __webpack_public_path__ + "static/media/Twitter.356a1a9c.svg";